<template>
  <div class="bottomBox">
    <div class="bottom">
      <div @click="btnFn(11, policy1)" v-if="_myData.order"  class="policy1"></div>
      <div @click="btnFn(21, policy2)" v-if="_myData.order"  class="policy2"></div>
      <div @click="btnFn(31, policy3)" v-if="_myData.order"  class="policy3"></div>
      <div @click="btnFn(41, policy4)" v-if="_myData.order"  class="policy4"></div>
  </div>

</div>
</template>

<script>
import { mapState } from "vuex";
export default {
  computed: {
    ...mapState(["_myData"]),
    policy1() {
      return window.location.origin + '/protocol?id=' + this._myData.order.law_article_id;
    },
    policy2() {
      return window.location.origin + '/protocol?id=' + this._myData.order.rule_article_id;
    },
    policy3() {
      return window.location.origin + '/protocol?id=' + this._myData.order.special_law_article_id;
    },
    policy4() {
      return window.location.origin + '/protocol?id=' + this._myData.order.fund_settlement_law_id;
    },
  },
  methods: {
    btnFn(code, url) {
      window.open(url);
    }
  }
};
</script>

<style lang="scss" scope>
.bottomBox {
    width: 100%;
    background-color: rgba(9, 13, 22, 1);
}
  .bottom {
    width: 1920px;
    height: 210px;
    position: relative;
    margin: auto;
    background-size: 100% 100%;
    background-position: center;
    margin-left: 50%;
    transform: translateX(-50%);
    background: url('~@/assets/images/bottom.jpeg') no-repeat;
    .policy1,
    .policy2,
    .policy3,
    .policy4 {
      display: block;
      width: 70px;
      height: 26px;
      position: absolute;
      left: 0;
      top: 0;
      bottom: 0;
      right: 0;
      margin: auto;
      margin-top: 30px;
      cursor: pointer;
    }

    .policy1{
      width: 150px;
      transform: translateX(-120px);
    }

    .policy2 {
      transform: translateX(35px);
    }

    .policy3 {
      width: 180px;
      transform: translateX(205px);
    }

    .policy4 {
      width: 170px;
      transform: translateX(430px);
    }
  }
</style>
